import { FAQ } from '@uc/shared/data-models';
import {
	ClientFeatures,
	FeaturedClearing,
	UniversitySection,
	UniversitySections,
} from '@uc/web/shared/data-models';
import {
	UNIVERSITY_INFORMATION,
	CAMPUS_LIFE,
	TUITION_FEES,
} from '../static/university.properties';

export class UniversityUtils {
	selectUniversitySectionData(
		universitySections: UniversitySections | undefined,
	): (UniversitySection | undefined)[] {
		return [
			this.selectObject(universitySections, UNIVERSITY_INFORMATION),
			this.selectObject(universitySections, CAMPUS_LIFE),
			this.selectObject(universitySections, TUITION_FEES),
		];
	}

	/*
	 * Returns an object of objects with the specified keys in the keys argument
	 */
	selectObject(
		object: Record<string, any> | undefined,
		keys: string[],
	): UniversitySection | undefined {
		if (!object || keys?.length === 0) return;
		return Object.fromEntries(
			keys.filter((key) => key in object).map((key) => [key, object[key]]),
		);
	}

	isPreviewMode(paidFeatures: string[], preview: boolean): boolean {
		if (
			(paidFeatures.includes(ClientFeatures.UnderPreview) ||
				paidFeatures.includes(ClientFeatures.PostPreview)) &&
			preview === true
		) {
			return true;
		}
		return false;
	}

	shouldDisplayFaq(isPreviewMode: boolean, faqs: FAQ[]) {
		if (isPreviewMode) {
			return false;
		}

		return Array.isArray(faqs) && faqs.length > 0;
	}

	getCourseAvailabilityFaqAnswer(
		isPreClearing: boolean,
		isPostClearing: boolean,
		uniName: string,
		currentClearingYear: number,
		isFeaturedClearing: FeaturedClearing,
	) {
		if (isPreClearing) {
			return `Clearing ${currentClearingYear} starts in July. Check back then to see if ${uniName} has any available courses.`;
		}

		if (isPostClearing) {
			return `Clearing has now closed at Uni Compare. Check back next year for Clearing ${
				currentClearingYear + 1
			}.`;
		}

		if (isFeaturedClearing) {
			return `Yes! ${uniName} currently has places available through Clearing at Uni Compare. If you're interested in a course, contact ${uniName} to secure your place as there's only limited spaces available.`;
		}

		return `Download our Clearing app and create an account to find your place in Clearing ${currentClearingYear}`;
	}
}
